export default __webpack_public_path__ + "static/media/A_05_05_bg_v03.5c6dc37e.mp4";